import React, {useContext, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Media from 'react-media';
import {getResizeImagePaths, onImageError} from '../../../../utils';
import {Icon, ThemeContext} from '../../../common';

const QuestionImage = (props) => {
  const {url, title, onPreviewClicked, previewHidden, fullwidth, isInterstitial} = props;
  const style = classNames(
    'question__image',
    {
      question__image_full: previewHidden,
      image__interstitial: isInterstitial,
    }
  );
  const imageWidth = fullwidth ? 542 : 180;
  const {defaultImageURL, resizedImageURL} = getResizeImagePaths(url, imageWidth);
  const {primaryColor} = useContext(ThemeContext);

  return (
    <div className={style}>
      <Media queries={{phone: {maxWidth: 700}}}>
        {
          matches =>
            (
              matches.phone ? (
                <Fragment>
                  {isInterstitial ? (
                    <img
                      src={resizedImageURL}
                      onError={onImageError(defaultImageURL)}
                      alt={title}
                    />
                  ) : (
                    <div onClick={onPreviewClicked}>
                      <svg width="48px" height="48px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                          <g id="PhotoIcon" fill={primaryColor}>
                            <path d="M100,0 C155.228475,0 200,44.771525 200,100 C200,155.228475 155.228475,200 100,200 C44.771525,200 0,155.228475 0,100 C0,44.771525 44.771525,0 100,0 Z M150.09375,53 L46.90625,53 C43.5989596,53 40.7877592,54.1545151 38.4726562,56.4635417 C36.2465958,58.6837595 35.0907549,61.3614435 35.0051371,64.496587 L35,64.875 L35,136.125 C35,139.42361 36.1575533,142.227432 38.4726562,144.536458 C40.6987167,146.756676 43.3834473,147.909483 46.5268412,147.994876 L46.90625,148 L150.09375,148 C153.40104,148 156.212241,146.845485 158.527344,144.536458 C160.753404,142.316241 161.909245,139.638557 161.994863,136.503413 L162,136.125 L162,64.875 C162,61.5763901 160.842447,58.7725682 158.527344,56.4635417 C156.301283,54.2433239 153.616553,53.0905167 150.473159,53.0051236 L150.09375,53 Z M149.514423,66 C149.84455,66 150.174681,66.1643531 150.504808,66.4930556 C150.793669,66.7806702 150.956155,67.0682877 150.992263,67.3559031 L151,67.4791667 L151,135.520833 C151,135.849536 150.834935,136.178242 150.504808,136.506944 C150.174681,136.835647 149.84455,137 149.514423,137 L49.4855769,137 C49.15545,137 48.8253193,136.835647 48.4951923,136.506944 C48.2063312,136.21933 48.0438454,135.931712 48.0077374,135.644097 L48,135.520833 L48,67.4791667 C48,67.1504642 48.1650654,66.821758 48.4951923,66.4930556 C48.7840534,66.2054409 49.0729174,66.0436562 49.3617792,66.007704 L49.4855769,66 L149.514423,66 Z M115,82 C114.242425,82 113.62259,82.2029868 113.140496,82.6089604 L113,82.7368421 L83,112.210526 L73,102.385965 C72.5,101.894737 71.8333321,101.649123 71,101.649123 C70.2424254,101.649123 69.6225897,101.85211 69.1404959,102.258083 L69,102.385965 L59,112.210526 L59,124 L139,124 L139,104.350877 L117,82.7368421 C116.5,82.245614 115.833332,82 115,82 Z M67,75 C64.1666679,75 61.7916679,75.9583321 59.875,77.875 C57.9583321,79.7916679 57,82.1666679 57,85 C57,87.8333321 57.9583321,90.2083321 59.875,92.125 C61.7916679,94.0416679 64.1666679,95 67,95 C69.8333321,95 72.2083321,94.0416679 74.125,92.125 C76.0416679,90.2083321 77,87.8333321 77,85 C77,82.1666679 76.0416679,79.7916679 74.125,77.875 C72.2083321,75.9583321 69.8333321,75 67,75 Z" id="Combined-Shape"/>
                          </g>
                        </g>
                      </svg>
                    </div>
                  )
                  }
                </Fragment>
              ) : (
                <Fragment>
                  <img
                    src={resizedImageURL}
                    onError={onImageError(defaultImageURL)}
                    alt={title}
                  />
                  {
                    !previewHidden && <span
                      style={{backgroundColor: primaryColor}}
                      className="preview-image"
                      role="button"
                      tabIndex={0}
                      onClick={onPreviewClicked}
                    >
                      <Icon glyph="arrows-alt"/>
                    </span>
                  }
                </Fragment>
              )
            )
        }
      </Media>
    </div>
  );
};

QuestionImage.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string,
  onPreviewClicked: PropTypes.func,
  previewHidden: PropTypes.bool,
  fullwidth: PropTypes.bool,
  isInterstitial: PropTypes.bool,
};

QuestionImage.defaultProps = {
  title: '',
  onPreviewClicked: () => {},
  previewHidden: false,
  isInterstitial: false,
  fullwidth: false,
};

export default QuestionImage;
